export default "__VITE_ASSET__nTx8fvkr__"